import { base32hex } from 'rfc4648'

/**
 * Encodes a string to Unicode-safe Base64.
 * https://developer.mozilla.org/en-US/docs/Glossary/Base64#the_unicode_problem
 * @param str - The string to encode.
 * @returns The Unicode-safe Base64 encoded string.
 */
export function base64Encode(str: string): string {
  const binString = Array.from(new TextEncoder().encode(str), (byte) =>
    String.fromCodePoint(byte)
  ).join('')
  return btoa(binString)
}

/**
 * Decodes a Unicode-safe Base64 encoded string.
 * https://developer.mozilla.org/en-US/docs/Glossary/Base64#the_unicode_problem
 * @param str - The Unicode-safe Base64 encoded string to decode.
 * @returns The decoded string.
 */
export function base64Decode(base64encoded: string): string {
  const binString = atob(base64encoded)
  return new TextDecoder().decode(
    new Uint8Array(binString.split('').map((char) => char.charCodeAt(0)))
  )
}

export function base32hexEncode(
  str: string,
  { pad }: { pad: boolean } = { pad: false }
): string {
  return base32hex.stringify(new TextEncoder().encode(str), { pad })
}

export function base32hexDecode(base32hexencoded: string): string {
  return new TextDecoder().decode(base32hex.parse(base32hexencoded))
}
